import React from 'react';
import TemplatePage from '../../components/TemplatePage/TemplatePage';
import { teluguData } from '../../data/departmentalData/telugu';

const Telugu = () => {
  return <TemplatePage data={teluguData} />;
};

export default Telugu;
